/* eslint-disable no-console */
import React, { Fragment, useEffect } from 'react';
import { DatePicker } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons';
import dayjs from 'dayjs';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import H3Text from '@Uilib/h3Text';
import H3FormInput from '@Uilib/h3FormInput';
import WarehouseLocationSelector from '../../../../Common/Selector/WarehouseLocationSelector';
import BatchHelpers from "@Helpers/BatchHelpers";
import './style.scss';

const FGInwardBatch = ({
  org, item, formSubmitted, data, destDepartmentId, enabledWarehouseLocations, hideCost, setIsBatchValid, updateData, user, priceMasking,
}) => {
  const batchConfig = org?.organisation?.[0]?.inventory_config?.settings?.batch_management;
  useEffect(() => {
    const isValid = BatchHelpers.validateBatchDetailsSimple(batchConfig, data, hideCost);
    setIsBatchValid(isValid);
  }, [data, batchConfig, formSubmitted]);

  const { isDataMaskingPolicyEnable, isHideCostPrice, isHideSellingPrice } = priceMasking;

  const batchConfigs = [
    {
      name: 'Cost Price',
      input_type: 'text',
      is_enabled: true,
      is_mandatory: batchConfig?.cost_price_is_mandatory,
      is_disabled: item?.selectedBatch?.batch_id,
      value: item?.selectedBatch?.cost_price ? item?.selectedBatch?.cost_price : '',
      key: 'cost_price',
      hideCost: true,
      hideInput: (isDataMaskingPolicyEnable && isHideCostPrice),
      popOverMessage: "You don't have access to view cost price",
    },
    {
      name: 'Lot #',
      input_type: 'text',
      is_enabled: batchConfig?.lot_number_is_enabled,
      is_mandatory: batchConfig?.lot_number_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.lot_number,
      key: 'lot_number',
      hideCost: true,
    },
    {
      name: 'MRP',
      input_type: 'number',
      is_enabled: batchConfig?.mrp_is_enabled,
      is_mandatory: batchConfig?.mrp_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.mrp,
      key: 'mrp',
      hideCost: true,
    },
    {
      name: 'Selling Price',
      input_type: 'number',
      is_enabled: batchConfig?.selling_price_is_enabled,
      is_mandatory: batchConfig?.selling_price_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.selling_price,
      key: 'selling_price',
      hideCost: true,
      hideInput: (isDataMaskingPolicyEnable && isHideSellingPrice),
      popOverMessage: "You don't have access to view selling price",
    },
    {
      name: 'AR Number',
      input_type: 'text',
      is_enabled: batchConfig?.ar_number_is_enabled,
      is_mandatory: batchConfig?.ar_number_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.ar_number,
      key: 'ar_number',
      hideCost: true,
    },
    {
      name: 'Roll No',
      input_type: 'text',
      is_enabled: batchConfig?.roll_no_is_enabled,
      is_mandatory: batchConfig?.roll_no_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.roll_no,
      key: 'roll_no',
      hideCost: true,
    },
    {
      name: 'Freight Cost',
      input_type: 'number',
      is_enabled: batchConfig?.freight_cost_is_enabled,
      is_mandatory: batchConfig?.freight_cost_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.freight_cost,
      key: 'freight_cost',
      hideCost: !hideCost,
    },
    {
      name: 'Other Cost',
      input_type: 'number',
      is_enabled: batchConfig?.other_cost_is_enabled,
      is_mandatory: batchConfig?.other_cost_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.other_cost,
      key: 'other_cost',
      hideCost: !hideCost,
    },
    {
      name: 'Brand',
      input_type: 'text',
      is_enabled: batchConfig?.brand_is_enabled,
      is_mandatory: batchConfig?.brand_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.brand,
      key: 'brand',
      hideCost: true,
    },
    {
      name: 'Mfg Batch No',
      input_type: 'text',
      is_enabled: batchConfig?.mfg_batch_no_is_enabled,
      is_mandatory: batchConfig?.mfg_batch_no_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.mfg_batch_no,
      key: 'mfg_batch_no',
      hideCost: true,
    },
    {
      name: 'Mfg Date',
      input_type: 'date',
      is_enabled: batchConfig?.manufacturing_date_is_enabled,
      is_mandatory: batchConfig?.manufacturing_date_is_mandatory,
      is_disabled: false,
      value: item?.selectedBatch?.manufacturing_date ? dayjs(item?.selectedBatch?.manufacturing_date) : '',
      key: 'manufacturing_date',
      hideCost: true,
      manufacturingDateFormat: item?.manufacturingDateFormat,
    },
  ];

  const mandatoryConfigs = [
    {
      name: 'Batch #',
      input_type: 'text',
      is_enabled: true,
      is_mandatory: true,
      is_disabled: item?.selectedBatch?.batch_id,
      value: (item?.selectedBatch?.custom_batch_number || item?.selectedBatch?.batch_number) ? (item?.selectedBatch?.custom_batch_number || item?.selectedBatch?.batch_number) : '',
      key: 'custom_batch_number',
      hideCost: true,
    },
  ];

  for (let i = 0; i < batchConfigs?.length; i++) {
    if (batchConfigs[i]?.is_mandatory) {
      mandatoryConfigs.push(batchConfigs[i]);
    }
  }

  return (
    <Fragment>
      {(!['NON_STORABLE', 'SERVICE'].includes(item?.product_sku_info?.product_type) && item?.tenant_product_info) ? (
        <Fragment>
          <div style={{ width: '240px' }} className="fg-inward-batch__batch-input">
            {mandatoryConfigs?.length > 0 && mandatoryConfigs?.map((innerConfig) => (
              innerConfig?.is_enabled && innerConfig?.hideCost && (
                innerConfig?.input_type === 'date' ? (
                  <div
                    className={`fg-inward-batch__input-wrapper`}
                    style={{ marginTop: '3px' }}
                  >
                    <H3Text
                      text="Mfg Date"
                      className="fg-inward-batch__input-label"
                      required={innerConfig?.is_mandatory}
                    />
                    &nbsp;
                    <DatePicker
                      value={innerConfig?.value}
                      onChange={(value) => {
                        const copyData = JSON.parse(JSON.stringify(data));

                        const updatedData = copyData.map((obj) => {
                          if ((obj.po_line_id === item.po_line_id && obj?.po_line_id) || (obj?.grn_line_id === item?.grn_line_id && item?.grn_line_id) || (obj?.key === item?.key && item?.key)) {
                            const newSelectedBatch = { ...JSON.parse(JSON.stringify(obj?.selectedBatch)), [innerConfig?.key]: value };
                            return {
                              ...obj,
                              selectedBatch: newSelectedBatch,
                            };
                          }
                          return obj;
                        });
                        updateData(updatedData);
                      }}
                      format={innerConfig?.manufacturingDateFormat}
                      picker={innerConfig?.manufacturingDateFormat !== 'DD/MM/YYYY' ? 'month' : ''}
                      className={`fg-inward-batch__input-date ${(formSubmitted && innerConfig?.is_mandatory && !innerConfig?.value) ? 'orgFormInputError' : ''}`}
                    />
                  </div>
                ) : (
                  <div
                    className="fg-inward-batch__input-wrapper"
                    style={{ marginTop: '3px' }}
                  >
                    <H3Text
                      text={innerConfig?.name}
                      className="fg-inward-batch__input-label"
                      required={innerConfig?.is_mandatory}
                    />
                    &nbsp;
                    <H3FormInput
                      value={innerConfig?.value ? innerConfig?.value : ''}
                      type={innerConfig?.input_type}
                      containerClassName={` ${(formSubmitted && !innerConfig?.value) ? 'create-pr__input' : ''}`}
                      labelClassName="orgFormLabel"
                      inputClassName={`orgFormInput ${(formSubmitted && innerConfig?.is_mandatory && !innerConfig?.value) ? 'orgFormInputError' : ''} `}
                      onChange={(event) => {
                        const copyData = JSON.parse(JSON.stringify(data));
                        const updatedData = copyData.map((obj) => {
                          if (obj?.key === item?.key && item?.key) {
                            const newSelectedBatch = {
                              ...JSON.parse(JSON.stringify(obj?.selectedBatch)),
                              [innerConfig?.key]: event?.target?.value,
                            };
                            return {
                              ...obj,
                              // available_batches: [newSelectedBatch, ...obj?.available_batches?.filter((i) => i?.batch_id)],
                              selectedBatch: newSelectedBatch,
                            };
                          }
                          return obj;
                        });
                        updateData(updatedData);
                      }}
                      hideInput={innerConfig.hideInput}
                      popOverMessage={innerConfig.popOverMessage}
                    />
                  </div>
                )
              )
            ))}
            {((item?.expiryDays || item?.expiry_days) >= 0) && (
              <div
                className={`fg-inward-batch__input-wrapper `}
                style={{ marginTop: '3px' }}
              >
                <H3Text text="Expiry" className="fg-inward-batch__input-label" />
                &nbsp;
                {/* {item?.selectedBatch?.expiry_date?.toString()} */}
                <DatePicker
                  value={dayjs(item?.selectedBatch?.expiry_date)}
                  onChange={(value) => {
                    const copyData = JSON.parse(JSON.stringify(data));

                    const updatedData = copyData.map((obj) => {
                      if (obj?.key === item?.key && item?.key) {
                        const newSelectedBatch = { ...JSON.parse(JSON.stringify(obj?.selectedBatch)), expiry_date: value };
                        return {
                          ...obj,
                          // available_batches: [newSelectedBatch, ...obj?.available_batches?.filter((i) => i?.batch_id)],
                          selectedBatch: newSelectedBatch,
                        };
                      }
                      return obj;
                    });
                    updateData(updatedData);
                  }}
                  format={item?.expiryDateFormat}
                  picker={item?.expiryDateFormat !== 'DD/MM/YYYY' ? 'month' : undefined}
                  className="fg-inward-batch__input-date"
                />
              </div>
            )}
            {enabledWarehouseLocations && (
              <div className={`fg-inward-batch__input-wrapper `} style={{ marginTop: '3px' }}>
                <H3Text
                  text="Shelf/Rack"
                  className="fg-inward-batch__input-label"
                  required={batchConfig?.inventory_location_is_mandatory}
                />
                <WarehouseLocationSelector
                  containerClassName="fg-inward-batch__input-select"
                  hideTitle
                  selectedInventoryLocation={item?.selectedBatch?.inventory_location_path}
                  onChange={(id, name) => {
                    const copyData = JSON.parse(JSON.stringify(data));
                    const updatedData = copyData.map((obj) => {

                      if (obj?.key === item?.key && item?.key) {
                        const newSelectedBatch = {
                          ...JSON.parse(JSON.stringify(obj?.selectedBatch)),
                          inventory_location_id: id,
                          inventory_location_path: name,
                        };
                        return {
                          ...obj,
                          selectedBatch: newSelectedBatch,
                        };
                      }
                      return obj;
                    });
                    updateData(updatedData);
                  }}
                  destDepartmentId={destDepartmentId}
                />
              </div>
            )}
            {item?.showMoreBatchInfo && (
              <Fragment>
                {batchConfigs?.filter((item) => !item?.is_mandatory)?.map((innerConfig) => (
                  innerConfig?.is_enabled && innerConfig?.hideCost && (
                    innerConfig?.input_type === 'date' ? (
                      <div
                        className={`fg-inward-batch__input-wrapper `}
                        style={{ marginTop: '3px' }}
                      >
                        <H3Text
                          text="Mfg Date"
                          className="fg-inward-batch__input-label"
                          required={batchConfig?.manufacturing_date_is_mandatory}
                        />
                        &nbsp;
                        <DatePicker
                          value={item?.selectedBatch?.manufacturing_date ? dayjs(item?.selectedBatch?.manufacturing_date) : ''}
                          onChange={(value) => {
                            const copyData = JSON.parse(JSON.stringify(data));

                            const updatedData = copyData.map((obj) => {
                              if (obj?.key === item?.key && item?.key) {
                                const newSelectedBatch = { ...JSON.parse(JSON.stringify(obj?.selectedBatch)), manufacturing_date: value };
                                return {
                                  ...obj,
                                  selectedBatch: newSelectedBatch,
                                };
                              }
                              return obj;
                            });
                            updateData(updatedData);
                          }}
                          format={innerConfig?.manufacturingDateFormat}
                          picker={innerConfig?.manufacturingDateFormat !== 'DD/MM/YYYY' ? 'month' : ''}
                          className={`fg-inward-batch__input-date ${(formSubmitted && batchConfig?.manufacturing_date_is_mandatory && !item.selectedBatch?.manufacturing_date) ? 'orgFormInputError' : ''}`}
                        />
                      </div>
                    ) : (
                      <div
                        className={`fg-inward-batch__input-wrapper `}
                        //  className="fg-inward-batch__input-wrapper"
                        style={{ marginTop: '3px' }}
                      >
                        <H3Text
                          text={innerConfig?.name}
                          className="fg-inward-batch__input-label"
                          required={innerConfig?.is_mandatory}
                        />
                        &nbsp;
                        <H3FormInput
                          value={innerConfig?.value ? innerConfig?.value : ''}
                          type={innerConfig?.input_type}
                          containerClassName={` ${(formSubmitted && !innerConfig?.value) ? 'create-pr__input' : ''}`}
                          labelClassName="orgFormLabel"
                          inputClassName={`orgFormInput ${(formSubmitted && innerConfig?.is_mandatory && !innerConfig?.value) ? 'orgFormInputError' : ''} `}
                          onChange={(event) => {
                            const copyData = JSON.parse(JSON.stringify(data));
                            const updatedData = copyData.map((obj) => {
                              if (obj?.key === item?.key && item?.key) {
                                const newSelectedBatch = {
                                  ...JSON.parse(JSON.stringify(obj?.selectedBatch)),
                                  [innerConfig?.key]: event?.target?.value,
                                };
                                return {
                                  ...obj,
                                  // available_batches: [newSelectedBatch, ...obj?.available_batches?.filter((i) => i?.batch_id)],
                                  selectedBatch: newSelectedBatch,
                                };
                              }
                              return obj;
                            });
                            updateData(updatedData);
                          }}
                          hideInput={innerConfig.hideInput}
                          popOverMessage={innerConfig.popOverMessage}
                        />
                      </div>
                    )
                  )
                ))}
              </Fragment>
            )}
          </div>
          <div className="flex-display">
            <div
              onClick={() => {
                const copyData = JSON.parse(JSON.stringify(data));
                const updatedData = copyData.map((obj) => {
                  if (obj?.key === item?.key && item?.key) {
                    return { ...obj, showMoreBatchInfo: !obj?.showMoreBatchInfo };
                  }
                  return obj;
                });
                updateData(updatedData);
              }}
              className="more-batch-info"
              style={{
                display: 'flex',
                alignItems: 'center',
                width: '100px',
              }}
            >
              <div>

                {`show ${item?.showMoreBatchInfo ? 'less' : 'more'}`}
              </div>
              &nbsp;
              {!item?.showMoreBatchInfo ? <FontAwesomeIcon icon={faChevronDown} /> : <FontAwesomeIcon icon={faChevronUp} />}
            </div>
          </div>
        </Fragment>
      ) : '-'}
    </Fragment>
  );
};

const mapStateToProps = ({
  UserReducers,
}) => ({
  user: UserReducers.user,
  MONEY: UserReducers.MONEY,
  org: UserReducers.org,
  priceMasking: UserReducers.priceMasking,
});

export default connect(mapStateToProps)(withRouter(FGInwardBatch));
